import { AxiosResponse } from "axios";
import { APIClient } from "../axiosClient";
import { ICoin, ICoinSearch } from "../types/newshub/_coin";
import { PaginationResponse, ResponseData } from "../types/_public";
import { ICategory } from "../types/newshub/_category";
import { PATH_NEWSHUB_API } from "helpers/newshub/constans";
const api = new APIClient();

const path_coins = PATH_NEWSHUB_API + '/coins';

const coinApi = {
  coins(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<ICoinSearch[]> & PaginationResponse, any>> {
    const url = `${path_coins}/candles`;
    return api.get(url, params);
  },
  searchCategories(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<ICategory[]>, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/categories`;
    return api.get(url, params);
  },
  allCoins(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<ICoin[]> & PaginationResponse, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/coins`;
    return api.get(url, params);
  },
};
export default coinApi;
